import React from 'react';
import { createUseStyles } from 'react-jss';

import { useWindowSize } from '../hooks/useWindowSize';
import { media, xs } from '../utils/constants';

const useStyles = createUseStyles((theme) => ({
  header: {
    composes: 'flexRow spaceBetween stretchSelf flex1',
    [media.xsDown]: {
      flexDirection: 'column',
      flex: 1,
    },
  },
  menu: {
    composes: 'flexRow center stretchSelf',
    [media.xsDown]: {
      flex: 1,
      justifyContent: 'space-between',
    },
  },
  nav: {
    composes: 'flexRow center',
    [media.smDown]: {
      justifyContent: 'flex-start',
    },
    // [media.xsDown]: {
    //   flexDirection: 'column',
    //   alignItems: 'flex-start',
    //   backgroundColor: 'blue'
    // },
  },
  ul: {
    composes: 'flexRow center',
    color: 'aliceblue',
    fontSize: 12,
    fontWeight: 400,
    '& > li': {
      display: 'flex',
      alignItems: 'center',
      alignSelf: 'stretch',
      listStyle: 'none',
      marginLeft: 12,
    },
    [media.xsDown]: {
      justifyContent: 'space-between',
      flex: 1,
    },
    [media.smDown]: {
      padding: 0,
    },
  },
  help: {},
  helpLink: {
    padding: 0,
    border: 0,
    backgroundColor: 'transparent',
    textDecoration: 'none',
    cursor: 'pointer',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    color: theme.colors.active,
    fontSize: 14,
    [media.smDown]: {
      fontSize: 12,
    },
    '&:hover': {
      textDecoration: 'underline'
    },
  },
  buttonContainer: {},
  button: {
    display: 'inline-block',
    margin: 0,
    padding: '.375rem 1.125rem',
    border: 0,
    borderRadius: '.25rem',
    boxShadow: '0 0 0 2px #dddde5 inset',
    fontWeight: 700,
    lineHeight: '1.5rem',
    textAlign: 'center',
    textDecoration: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0 0 0 2px ' + theme.colors.active + ' inset',
    }
  },
  buttonContent: {},
  buttonText: {
    color: theme.colors.primary,
    fontSize: 12,
    fontWeight: 400,
    [media.smDown]: {
      fontSize: 10,
    },
  },
  flag: {
    height: 12,
    marginRight: '.25rem',
    marginLeft: '.5rem',
    border: '1px solid #dddde5',
    boxSizing: 'content-box',
  },
  currency: {
    marginLeft: '.5rem',
    color: '#b2b2bf',
    fontSize: 12,
    fontWeight: 400,
    [media.smDown]: {
      fontSize: 10,
    },
  },
  loginButtonContainer: {
  },
  loginButton: {
    backgroundImage: 'none',
    color: theme.colors.active,
    backgroundColor: '#fff',
    boxShadow: 'inset 0 0 0 2px #dddde5',
    height: '100%',
    fontSize: 19,

    margin: 0,
    padding: '.375rem 1.125rem',
    border: 0,
    borderRadius: '.25rem',

    [media.smDown]: {
      fontSize: 12,
      padding: '.375rem 1rem',
    },
  },
  helpButtonContainer: {
    marginLeft: theme.spacing(16),
    [media.lgDown]: {
      marginLeft: theme.spacing(0),
    }
  },
  helpButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
}));

const Header = () => {
  const classes = useStyles();

  const { width } = useWindowSize();


  const helpButton = (
    <button type="button" className={classes.helpButton}>
      <svg id="svg2" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <path id="path2382" d="M17.74,9A8.74,8.74,0,0,1,.26,9h0A8.74,8.74,0,0,1,17.74,9Z" fill="#fff" />
        <g id="layer1">
          <path id="path2413" d="M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,1.15A7.85,7.85,0,1,1,1.15,9,7.86,7.86,0,0,1,9,1.15Zm.13,1.92a4.94,4.94,0,0,0-1.37.18,3.57,3.57,0,0,0-1.16.56,3.8,3.8,0,0,0-.78.77,3.1,3.1,0,0,0-.64,1.68.38.38,0,0,1,0,.08l2,.24a.33.33,0,0,0,0-.08A2.3,2.3,0,0,1,8.15,5a2.28,2.28,0,0,1,1.42-.26,1.69,1.69,0,0,1,.66.18,1.59,1.59,0,0,1,.63.52,1.36,1.36,0,0,1,.25.66,2.81,2.81,0,0,1,0,.29,1.32,1.32,0,0,1-.13.44,1.07,1.07,0,0,1-.25.35c-.18.18-.47.43-1,.84A8.91,8.91,0,0,0,9,8.67,2.56,2.56,0,0,0,8.25,10a4.91,4.91,0,0,0-.11,1.19c0,.12,0,.24,0,.26v0h1.94v-.21a3.81,3.81,0,0,1,.05-.67,1.23,1.23,0,0,1,.35-.7,6.67,6.67,0,0,1,.63-.58,12.54,12.54,0,0,0,1-.92A3.69,3.69,0,0,0,13,7.31a2.61,2.61,0,0,0,.23-.86V6.09a2.78,2.78,0,0,0-.74-1.71L12.13,4a3.66,3.66,0,0,0-1.58-.81,4.91,4.91,0,0,0-1.2-.16Zm-1,9.32v2h2v-2Z"/>
        </g>
      </svg>
    </button>
  );

  const languageButton = (
    <button className={classes.button}>
      <div className={classes.buttonContent}>
        <span className={classes.buttonText}>
          English (UK)
        </span>
        <img className={classes.flag} src="https://images.skyscnr.com/images/country/flag/header/mg.png" alt="MG" title="MG" />
        <span className={classes.buttonText}>
          Madagascar
        </span>
        <span className={classes.currency}>
          Ar MGA
        </span>
      </div>
    </button>
  );

  return (
    <div className={classes.header}>
      <div className={classes.menu}>
        <div>logo</div>
        {width <= xs && (
          <div className={classes.buttonContainer}>
            {languageButton}
          </div>
        )}   
      </div>
      
      <nav className={classes.nav}>
        <ul className={classes.ul}>
          <li className={classes.help}>
            <a className={classes.helpLink} href="/" target="_blank" rel="noopener">
              Help
            </a>
          </li>
          {width > xs && (
            <li className={classes.buttonContainer}>
              {languageButton}
            </li>
          )}
          <li className={classes.loginButtonContainer}>
            <button type="button" className={classes.loginButton} aria-label="Log in">
              Log in
            </button>
          </li>
          {width <= xs && (
            <li className={classes.helpButtonContainer}>
              {helpButton}
            </li>
          )}
        </ul>
        {width >= xs && (
          <div className={classes.helpButtonContainer}>
            {helpButton}
          </div>
        )}
      </nav>
    </div>
  );
};

export default Header;